module.exports = __webpack_public_path__ + "img/4.7ce3c707.png";